export default __webpack_public_path__ + "static/media/1.025f7de0.webp";